export const SET_AREAS = 'SET_AREAS'
export const SET_AREA = 'SET_AREA'
export const SET_AREAS_LENGTH = 'SET_AREAS_LENGTH'
export const SET_SHOW_AREA_FORM = 'SET_SHOW_AREA_FORM'
export const APPEND_AREAS = 'APPEND_AREAS'
export const SET_SHOW_CREATE_TABLES_FORM = 'SET_SHOW_CREATE_TABLES_FORM'
export const SET_SHOW_QR_CODE_DOWNLOAD_MODAL = 'SET_SHOW_QR_CODE_DOWNLOAD_MODAL'
export const SET_AREA_TABLES = 'SET_AREA_TABLES'
export const SET_AREA_QR_CODES_DATA_IS_LOADING = 'SET_AREA_QR_CODES_DATA_IS_LOADING'
